import React from 'react'
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import SavingsIcon from '@mui/icons-material/Savings';
import EventIcon from '@mui/icons-material/Event';


const GridBox = () => {
     return (
          <>
               <div className="row">
                    <div className="col ">
                         <div className="smallsize">
                              <div className="rowbox">
                                   <SavingsIcon />
                                   <h1>FMCG </h1>
                              </div>
                              <p>Fast-moving consumer goods are products that sell quickly at relatively low cost. These goods are also called consumer packaged goods. The Nepal FMCG sector is the largest manufacturing sector in the country accounting for 14% of all manufacturing. Our clients include the supply of beverage, liquors (Domestic & International), toiletries items and include the supply of products of large industries in Nepal such as Dabur Nepal Pvt. Ltd., JGI Pvt. Ltd., Unilever Nepal, etc.</p>
                         </div>
                    </div>

                    <div className="col" >
                         <div className="smallsize">
                              <div className="rowbox">
                                   <BusinessCenterIcon />
                                   <h1>Banks, Financial Institutions and Investment</h1>
                              </div>
                              <p>As financial services companies seek opportunities for growth, innovation and revenue, they must face risk, comply with regulations and vie for new customers in an evolving marketplace. Our clients include various cooperative societies in the Kathmandu valley.</p>
                         </div>
                    </div>
                    <div className="w-100"></div>

                    <div className="col">
                         <div className="smallsize">
                              <div className="rowbox">
                                   <MiscellaneousServicesIcon />
                                   <h1>Real Estate and Construction</h1>
                              </div>
                              <p>The real estate and construction sector is increasingly influenced by rapid technological advancements and significant demographic shifts, including growing urbanization, longevity of baby boomers, and differentiated lifestyle patterns of millennials. In addition, macroeconomic and regulatory developments continue to affect profitability. Executives have their hands full as they look to find ways to respond to these changes, gain a competitive advantage, and drive top- and bottom-line growth.</p>
                         </div>
                    </div>

                    <div className="col" >
                         <div className="smallsize">
                              <div className="rowbox">
                                   <EventIcon />
                                   <h1>Tech and EV</h1>
                              </div>
                              <p>There is a need for conveniently accessible charging points for the charging infrastructure to support the Nepalese electric vehicle market. As per reports, there are one million public charging points in the world and not only 0.1% are in Nepal. and this could be a great Business Opportunity to work in EVs Sector. Our clients include the company which supply and establish various charging stations overall the nation.</p>
                         </div>
                    </div>
               </div>
          </>
     )
}

export default GridBox